<template>
    <div>
        <label for="c">Campanha:</label>
        <b-form-input id="c" v-model="codigo" placeholder="Código da Campanha">
            
        </b-form-input>
    </div>
</template>

<script>

export default {
    name: 'campanha',
    props: {
        campanha: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            codigo: '',
        }
    },
    watch: {
        codigo() {
            if(this.codigo.length > 2) {
                console.log('buscar campanha', this.codigo);
                this.buscaCampanha();
            }
        }
    },
    methods: {
        buscaCampanha() {
            const vm = this
            const data = {
                campanha: vm.codigo
            }
            axios.get('/campanhas/getCampanha', data)
            .then((response) => {
                    console.log(response);
                }).catch((erro) => {
                    console.log(erro);
                })
        }
    },
}

</script>


// WEBPACK FOOTER //
// resources/assets/js/components/util/getCampanha.vue